import { render } from "./Goals.vue?vue&type=template&id=0a7fbd1c&scoped=true"
import script from "./Goals.vue?vue&type=script&lang=js"
export * from "./Goals.vue?vue&type=script&lang=js"

import "./Goals.vue?vue&type=style&index=0&id=0a7fbd1c&scoped=true&lang=css"

import exportComponent from "/home/kitrin/builds/isoevolve/20261004-205117/src/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0a7fbd1c"]])

export default __exports__